import { Badge } from '@/components/ui/badge';
import { Card } from '@/components/ui/card';
import { ClientLogo } from '@/components/ClientLogo';
import { allClients } from '@/data/clients';

export const ClientsPage = () => {
    return (
        <div className="overflow-hidden">
            {/* Hero Section */}
            <section className="relative min-h-[50vh] lg:min-h-[60vh] flex items-center pt-24 pb-12">
                {/* Background */}
                <div className="absolute inset-0 bg-muted/50" />
                <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-accent/5" />

                {/* Collage Background */}
                <div className="absolute inset-0 pointer-events-none" style={{ opacity: '0.06' }}>
                    <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6 p-8 lg:p-12">
                        {allClients.map((client, index) => (
                            <div
                                key={`${client.name}-${index}`}
                                className="bg-white/70 dark:bg-[hsl(215,50%,12%)]/70 rounded-xl flex items-center justify-center border border-white/60 dark:border-gray-700/40 px-4 py-6"
                            >
                                <ClientLogo
                                    name={client.name}
                                    logo={client.logo}
                                    imgClassName="w-full h-full object-contain opacity-70"
                                    textClassName="font-display text-[10px] text-muted-foreground text-center leading-tight opacity-70"
                                />
                            </div>
                        ))}
                    </div>
                </div>

                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-background" />

                <div className="container mx-auto px-4 lg:px-8 relative z-10">
                    <div className="max-w-3xl">
                        <Badge className="bg-accent/10 text-accent border-accent/20 mb-6 animate-fade-in">
                            TRUSTED BY
                        </Badge>
                        <h1 className="font-display text-5xl lg:text-7xl text-foreground leading-tight mb-6 animate-fade-in animation-delay-100">
                            OUR VALUED
                            <span className="text-accent block">CLIENTS</span>
                        </h1>
                        <p className="text-muted-foreground text-lg lg:text-xl leading-relaxed animate-fade-in animation-delay-200">
                            We are proud to serve a diverse portfolio of clients across Bangalore. Here is a
                            snapshot of the organizations that trust Shiva Security Services.
                        </p>
                    </div>
                </div>

                {/* Horizontal Divider */}
                <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-border to-transparent" />
            </section>

            {/* Clients Grid */}
            <section className="py-20 lg:py-32 px-4 lg:px-8">
                <div className="container mx-auto">
                    <div className="text-center max-w-3xl mx-auto mb-16">
                        <Badge className="bg-accent/10 text-accent border-accent/20 mb-4">
                            CLIENT PORTFOLIO
                        </Badge>
                        <h2 className="font-display text-4xl lg:text-5xl text-foreground mb-6">
                            TRUSTED PARTNERS
                        </h2>
                        <p className="text-muted-foreground text-lg">
                            From corporate offices to large residential communities, our clients rely on us
                            for consistent, professional security services.
                        </p>
                    </div>

                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                        {allClients.map((client, index) => (
                            <Card
                                key={`client-${index}`}
                                className="card-elevated p-2 flex items-center justify-center min-h-[120px]"
                            >
                                <ClientLogo
                                    name={client.name}
                                    logo={client.logo}
                                    imgClassName="w-full h-full object-contain"
                                    textClassName="font-display text-sm text-muted-foreground text-center leading-tight"
                                />
                            </Card>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ClientsPage;
